"use client"

import { useState, useEffect } from "react"
import ModernCategoryCard from "@/components/modern-category-card"
import MobileCategoryCard from "@/components/mobile/mobile-category-card"
import TextReveal from "@/components/animated/text-reveal"
import GradientBackground from "@/components/animated/gradient-background"
import Breadcrumbs from "@/components/seo/breadcrumbs"
import { categories } from "@/data/categories"

export default function CategoriesClientPage() {
  const [isMobile, setIsMobile] = useState(false)

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 768)
    }
    checkMobile()
    window.addEventListener("resize", checkMobile)
    return () => window.removeEventListener("resize", checkMobile)
  }, [])

  const allCategories = categories || []

  return (
    <div className="min-h-screen relative">
      <GradientBackground />

      <div className="container mx-auto px-4 py-8 relative z-10">
        {/* Breadcrumbs */}
        <Breadcrumbs items={[{ name: "Categories", url: "/categories" }]} />

        {/* Header */}
        <TextReveal>
          <div className="mb-12 text-center">
            <h1 className="text-4xl lg:text-5xl font-bold text-slate-900 mb-6">Product Categories</h1>
            <p className="text-xl text-slate-600 max-w-3xl mx-auto">
              Explore our comprehensive range of industrial hardware categories
            </p>
          </div>
        </TextReveal>

        {/* Categories Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {allCategories.map((category, index) =>
            isMobile ? (
              <MobileCategoryCard key={category.id} category={category} index={index} />
            ) : (
              <ModernCategoryCard key={category.id} category={category} index={index} />
            ),
          )}
        </div>

        {/* Mobile bottom spacing */}
        {isMobile && <div className="h-20" />}
      </div>
    </div>
  )
}
